module.exports = __webpack_public_path__ + "static/media/whiteWave.0aa4022a.svg";